module.exports = __webpack_public_path__ + "med-icon.png?9fc5450be7431e47078fe358e7d6abda";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/med-icon.png
// module id = 55
// module chunks = 0